import PageTitle from './PageTitle'
export { PageTitle }
export default PageTitle
